import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const api = axios.create({
  baseURL: API_URL,
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const authAPI = {
  login: (email: string, password: string) => 
    api.post('/auth/login', { email, password }),
  register: (userData: any) => 
    api.post('/auth/register', userData),
  getMe: () => 
    api.get('/auth/me'),
  forgotPassword: (email: string) =>
    api.post('/auth/forgot-password', { email }),
  validateResetToken: (token: string) =>
    api.get('/auth/reset-password/validate', { params: { token } }),
  resetPassword: (token: string, password: string) =>
    api.post('/auth/reset-password', { token, password }),
};

export const productsAPI = {
  getAll: () => 
    api.get('/products'),
  getAllAdmin: () => 
    api.get('/products/all'),
  getBySeason: (season: string) => 
    api.get(`/products/season/${season}`),
  create: (productData: any) => 
    api.post('/products', productData),
  update: (id: number, productData: any) => 
    api.put(`/products/${id}`, productData),
  updateInventory: (id: number, inventory: {
    inventory_count: number;
    low_stock_threshold: number;
    track_inventory: boolean;
  }) =>
    api.put(`/products/${id}/inventory`, inventory),
  delete: (id: number) => 
    api.delete(`/products/${id}`),
};

export const ordersAPI = {
  create: (orderData: any) => 
    api.post('/orders', orderData),
  getMyOrders: () => 
    api.get('/orders/my-orders'),
  getAll: () => 
    api.get('/orders'),
  updateStatus: (id: number, status: string) => 
    api.put(`/orders/${id}/status`, { status }),
  updatePaymentStatus: (id: number, isPaid: boolean) => 
    api.put(`/orders/${id}/payment`, { isPaid }),
};

export const usersAPI = {
  getAll: () => 
    api.get('/users'),
  updateRole: (id: number, role: string) => 
    api.put(`/users/${id}/role`, { role }),
  delete: (id: number) => 
    api.delete(`/users/${id}`),
};

export const paymentAPI = {
  createPaymentIntent: (amount: number, orderId: number) => 
    api.post('/payment/create-payment-intent', { amount, orderId }),
  confirmPayment: (paymentIntentId: string) => 
    api.post('/payment/confirm-payment', { paymentIntentId }),
};

export default api;